var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "mt-4 d-flex justify-center align-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Origem*",
      "outlined": "",
      "dense": "",
      "items": _vm.origensFiltradas,
      "item-text": "nome",
      "item-value": "id",
      "disabled": _vm.camposDesabilitados,
      "return-object": "",
      "rules": [_vm.$required]
    },
    on: {
      "change": _vm.verificarOrigemSelecionada
    },
    model: {
      value: _vm.content.origemId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "origemId", $$v);
      },
      expression: "content.origemId"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_vm.mostrarNomeGre ? _c('v-col', {
    attrs: {
      "cols": _vm.mostrarNomeGre && _vm.mostrarEscola ? 6 : 12
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Nome da GRE*",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "codigo",
      "return-object": "",
      "items": _vm.listaGerenciasRegionais,
      "rules": [_vm.$required],
      "disabled": _vm.camposDesabilitados
    },
    on: {
      "focus": _vm.ensureGerenciasLoaded,
      "change": _vm.atualizarGreIds
    },
    model: {
      value: _vm.content.greId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "greId", $$v);
      },
      expression: "content.greId"
    }
  })], 1) : _vm._e(), _vm.mostrarEscola ? _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "label": "Escola*",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "codigo",
      "multiple": "",
      "return-object": "",
      "items": _vm.listarEscolas,
      "rules": [_vm.$required],
      "disabled": !_vm.liberarEscola || _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.escolaId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "escolaId", $$v);
      },
      expression: "content.escolaId"
    }
  })], 1) : _vm._e(), _vm.mostrarSecretariaExecutiva ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Secretaria Executiva*",
      "dense": "",
      "outlined": "",
      "items": _vm.listaSecretarias,
      "item-text": "nome",
      "item-value": "codigo",
      "multiple": "",
      "return-object": "",
      "rules": [_vm.$required],
      "disabled": _vm.camposDesabilitados
    },
    on: {
      "focus": _vm.ensureSecretariasLoaded
    },
    model: {
      value: _vm.content.secretariaId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "secretariaId", $$v);
      },
      expression: "content.secretariaId"
    }
  })], 1) : _vm._e()], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('sigfoco-date-picker', {
    attrs: {
      "label": "Início da Formação*",
      "removeIcon": "",
      "dataEdicao": _vm.content.dataInicio,
      "outlined": "",
      "dense": "",
      "rules": [_vm.$required, function () {
        return _vm.validateData() || 'A data de início da formação não pode ser posterior à data de fim da formação.';
      }],
      "disabled": _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.content, "dataInicio", $$v);
      },
      expression: "content.dataInicio"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "label": "Final da Formação*",
      "removeIcon": "",
      "dataEdicao": _vm.content.dataFim,
      "outlined": "",
      "dense": "",
      "rules": [_vm.$required, function () {
        return _vm.validateData() || 'A data de fim da formação não pode ser anterior à data de início da formação.';
      }],
      "disabled": _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.content, "dataFim", $$v);
      },
      expression: "content.dataFim"
    }
  })], 1), _c('div', [_c('v-card', {
    staticClass: "pa-4 mt-3",
    attrs: {
      "outlined": ""
    }
  }, [_c('h3', [_vm._v("Formação Continuada para (Público Alvo):")]), _c('v-divider'), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Função*",
      "outlined": "",
      "dense": "",
      "items": _vm.funcoes,
      "item-text": "nome",
      "item-value": "id",
      "disabled": _vm.camposDesabilitados,
      "rules": [_vm.$required]
    },
    model: {
      value: _vm.content.funcaoId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "funcaoId", $$v);
      },
      expression: "content.funcaoId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "id": "etapaDeEnsinoId",
      "label": "Etapa de Ensino*",
      "outlined": "",
      "dense": "",
      "items": _vm.listaEtapas,
      "item-text": "nome",
      "item-value": "id",
      "disabled": _vm.camposDesabilitados,
      "rules": [_vm.$required]
    },
    on: {
      "focus": _vm.ensureEtapasLoaded
    },
    model: {
      value: _vm.content.etapaDeEnsinoId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "etapaDeEnsinoId", $$v);
      },
      expression: "content.etapaDeEnsinoId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_vm.deveExibirCampoDisciplina ? _c('v-autocomplete', {
    attrs: {
      "label": "Disciplina*",
      "outlined": "",
      "dense": "",
      "items": _vm.disciplinas,
      "item-text": "nomeDisciplina",
      "item-value": "id",
      "disabled": _vm.camposDesabilitados,
      "rules": [_vm.$required]
    },
    on: {
      "focus": _vm.ensureDisciplinasLoaded
    },
    model: {
      value: _vm.content.disciplinaId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "disciplinaId", $$v);
      },
      expression: "content.disciplinaId"
    }
  }) : _vm._e()], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da ação*",
      "counter": "200",
      "maxlength": "200",
      "dense": "",
      "outlined": "",
      "rules": [_vm.$required],
      "disabled": _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.nomeDaAcao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nomeDaAcao", $$v);
      },
      expression: "content.nomeDaAcao"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Objetivo Geral*",
      "counter": "500",
      "maxlength": "500",
      "placeholder": "Informe o objetivo geral",
      "outlined": "",
      "dense": "",
      "disabled": _vm.camposDesabilitados,
      "rules": [_vm.$required]
    },
    model: {
      value: _vm.content.objetivoGeral,
      callback: function ($$v) {
        _vm.$set(_vm.content, "objetivoGeral", $$v);
      },
      expression: "content.objetivoGeral"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Objetivos Específicos*",
      "placeholder": "Informe os objetivos específicos",
      "counter": "500",
      "maxlength": "500",
      "outlined": "",
      "dense": "",
      "disabled": _vm.camposDesabilitados,
      "rules": [_vm.$required]
    },
    model: {
      value: _vm.content.objetivoEspecifico,
      callback: function ($$v) {
        _vm.$set(_vm.content, "objetivoEspecifico", $$v);
      },
      expression: "content.objetivoEspecifico"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Local de Realização*",
      "counter": "200",
      "maxlength": "200",
      "dense": "",
      "outlined": "",
      "rules": [_vm.$required],
      "disabled": _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.localRealizacao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "localRealizacao", $$v);
      },
      expression: "content.localRealizacao"
    }
  })], 1)], 1)], 1), _c('v-card', {
    staticClass: "pa-4 mt-3",
    attrs: {
      "outlined": ""
    }
  }, [_c('h3', [_vm._v("Turmas:")]), _c('v-divider'), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Turma",
      "outlined": "",
      "counter": "50",
      "maxlength": "50",
      "dense": "",
      "disabled": _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.nomeTurma,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nomeTurma", $$v);
      },
      expression: "content.nomeTurma"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Turno",
      "dense": "",
      "outlined": "",
      "items": _vm.listaTurnos,
      "item-text": "descricao",
      "item-value": "turnoId",
      "return-object": "",
      "disabled": _vm.camposDesabilitados
    },
    on: {
      "focus": _vm.ensureTurnosLoaded,
      "change": _vm.validarHorarioTurno
    },
    model: {
      value: _vm.content.turnoId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "turnoId", $$v);
      },
      expression: "content.turnoId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    ref: "formHoraInicio",
    attrs: {
      "label": "Horário Início",
      "outlined": "",
      "dense": "",
      "maxlength": "5",
      "rules": [function (h) {
        return _vm.horaValida(h);
      }, function (h) {
        return _vm.validarFormatoHora(h) || 'O horário deve ser no formato HH:MM';
      }, function (h) {
        return _vm.horaNoTurnoEspecificado(h);
      }],
      "disabled": _vm.camposDesabilitados
    },
    on: {
      "keypress": _vm.$validarEntradaNumerica,
      "input": function ($event) {
        return _vm.formatarHoraInput('horaInicio', $event);
      }
    },
    model: {
      value: _vm.content.horaInicio,
      callback: function ($$v) {
        _vm.$set(_vm.content, "horaInicio", $$v);
      },
      expression: "content.horaInicio"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    ref: "formHoraFinal",
    attrs: {
      "label": "Horário Final",
      "outlined": "",
      "disabled": _vm.camposDesabilitados,
      "dense": "",
      "maxlength": "5",
      "rules": [function (h) {
        return _vm.horaValida(h);
      }, function (h) {
        return _vm.validarFormatoHora(h) || 'O horário deve ser no formato HH:MM';
      }, function (h) {
        return _vm.horaNoTurnoEspecificado(h);
      }]
    },
    on: {
      "keypress": _vm.$validarEntradaNumerica,
      "input": function ($event) {
        return _vm.formatarHoraInput('horaTermino', $event);
      }
    },
    model: {
      value: _vm.content.horaTermino,
      callback: function ($$v) {
        _vm.$set(_vm.content, "horaTermino", $$v);
      },
      expression: "content.horaTermino"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 3,
      "label": "Data",
      "removeIcon": "",
      "dataEdicao": _vm.content.dataRealizacao,
      "outlined": "",
      "dense": "",
      "disabled": _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.dataRealizacao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "dataRealizacao", $$v);
      },
      expression: "content.dataRealizacao"
    }
  }), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.podeAdicionarTurma || _vm.camposDesabilitados
    },
    on: {
      "click": _vm.adicionarAtualizarTurma
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Incluir ")], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "dense": "",
      "headers": _vm.headers,
      "items": _vm.content.relacaoTurmas,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.nomeTurma`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nomeTurma) + " ")];
      }
    }, {
      key: `item.nomeTurno`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.nomeTurno) + " ")];
      }
    }, {
      key: `item.dataRealizacao`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.$formatarData(item.dataRealizacao)) + " ")];
      }
    }, {
      key: `item.horaInicio`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.formatarHora(item.horaInicio)) + " ")];
      }
    }, {
      key: `item.horaTermino`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm.formatarHora(item.horaTermino)) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref6) {
        var item = _ref6.item,
          index = _ref6.index;
        return [_c('div', {
          key: index
        }, [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true,
            "disabled": _vm.camposDesabilitados
          },
          on: {
            "click": function ($event) {
              return _vm.editarTurma(item, index);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Excluir',
            "icon": 'mdi-delete',
            "small": true,
            "disabled": _vm.camposDesabilitados
          },
          on: {
            "click": function ($event) {
              return _vm.excluirTurma(item);
            }
          }
        })], 1)];
      }
    }], null, true)
  })], 1)], 1)], 1), _c('v-card', {
    staticClass: "pa-4 mt-3",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Número Total de Participantes*",
      "outlined": "",
      "counter": "4",
      "maxlength": "4",
      "inputmode": "numeric",
      "dense": "",
      "rules": [_vm.$required],
      "disabled": _vm.camposDesabilitados
    },
    on: {
      "keypress": _vm.$validarEntradaNumerica
    },
    model: {
      value: _vm.content.numeroTotalParticipantes,
      callback: function ($$v) {
        _vm.$set(_vm.content, "numeroTotalParticipantes", $$v);
      },
      expression: "content.numeroTotalParticipantes"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Quantidade de Turmas",
      "outlined": "",
      "couter": "15",
      "maxlength": "15",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: _vm.content.quantidadeDeTurmas,
      callback: function ($$v) {
        _vm.$set(_vm.content, "quantidadeDeTurmas", $$v);
      },
      expression: "content.quantidadeDeTurmas"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Carga Horária*",
      "outlined": "",
      "counter": "6",
      "type": "text",
      "dense": "",
      "rules": [_vm.$required, _vm.validarFormatoCargaHoraria],
      "disabled": _vm.camposDesabilitados
    },
    on: {
      "input": _vm.formatarCargaHoraria
    },
    model: {
      value: _vm.content.cargaHoraria,
      callback: function ($$v) {
        _vm.$set(_vm.content, "cargaHoraria", $$v);
      },
      expression: "content.cargaHoraria"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Conteúdo Programático*",
      "maxlength": "1000",
      "counter": "1000",
      "dense": "",
      "outlined": "",
      "rows": "6",
      "rules": [_vm.$required],
      "disabled": _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.conteudoProgramatico,
      callback: function ($$v) {
        _vm.$set(_vm.content, "conteudoProgramatico", $$v);
      },
      expression: "content.conteudoProgramatico"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Metodologia de Ensino*",
      "maxlength": "1000",
      "counter": "1000",
      "dense": "",
      "outlined": "",
      "rows": "6",
      "rules": [_vm.$required],
      "disabled": _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.metodologiaDeEnsino,
      callback: function ($$v) {
        _vm.$set(_vm.content, "metodologiaDeEnsino", $$v);
      },
      expression: "content.metodologiaDeEnsino"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Recursos Utilizados*",
      "maxlength": "500",
      "counter": "500",
      "dense": "",
      "outlined": "",
      "rows": "6",
      "rules": [_vm.$required],
      "disabled": _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.recursosUtilizados,
      callback: function ($$v) {
        _vm.$set(_vm.content, "recursosUtilizados", $$v);
      },
      expression: "content.recursosUtilizados"
    }
  })], 1)], 1)], 1), _c('v-card', {
    staticClass: "pa-4 mt-3",
    attrs: {
      "outlined": ""
    }
  }, [_c('h3', [_vm._v("Instrutoria e Coordenação:")]), _c('v-divider'), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome Completo do Coordenador",
      "outlined": "",
      "dense": "",
      "maxlength": "40",
      "counter": "40",
      "disabled": _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.nomeDoCoordenador,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nomeDoCoordenador", $$v);
      },
      expression: "content.nomeDoCoordenador"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Matrícula",
      "outlined": "",
      "maxlength": "12",
      "counter": "12",
      "hint": "A matrícula do servidor deve conter 12 números.",
      "persistent-hint": "",
      "dense": "",
      "inputmode": "numeric",
      "disabled": _vm.camposDesabilitados
    },
    on: {
      "keypress": _vm.$validarEntradaNumerica
    },
    model: {
      value: _vm.content.matriculaDoCoordenador,
      callback: function ($$v) {
        _vm.$set(_vm.content, "matriculaDoCoordenador", $$v);
      },
      expression: "content.matriculaDoCoordenador"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###.###.###-##',
      expression: "'###.###.###-##'"
    }],
    attrs: {
      "label": "CPF",
      "outlined": "",
      "maxlength": "14",
      "counter": "14",
      "dense": "",
      "disabled": _vm.camposDesabilitados
    },
    on: {
      "keypress": _vm.$validarEntradaNumerica,
      "input": function ($event) {
        return _vm.formatarCpfOnInput('cpfDoCoordenador', $event);
      }
    },
    model: {
      value: _vm.content.cpfDoCoordenador,
      callback: function ($$v) {
        _vm.$set(_vm.content, "cpfDoCoordenador", $$v);
      },
      expression: "content.cpfDoCoordenador"
    }
  })], 1), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.podeAdicionarCoordenador || _vm.camposDesabilitados
    },
    on: {
      "click": _vm.adicionarAtualizarCoordenador
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Incluir Coordenador ")], 1)], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "dense": "",
      "headers": _vm.headersCoordenadores,
      "items": _vm.content.coordenadores,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.nomeDoCoordenador`,
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_vm._v(" " + _vm._s(item.nomeDoCoordenador) + " ")];
      }
    }, {
      key: `item.matriculaDoCoordenador`,
      fn: function (_ref8) {
        var item = _ref8.item;
        return [_vm._v(" " + _vm._s(item.matriculaDoCoordenador) + " ")];
      }
    }, {
      key: `item.cpfDoCoordenador`,
      fn: function (_ref9) {
        var item = _ref9.item;
        return [_vm._v(" " + _vm._s(_vm.$esconderCpf(item.cpfDoCoordenador)) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref0) {
        var item = _ref0.item,
          index = _ref0.index;
        return [_c('div', {
          key: index
        }, [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true,
            "disabled": _vm.camposDesabilitados
          },
          on: {
            "click": function ($event) {
              return _vm.editarCoordenador(item, index);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Excluir',
            "icon": 'mdi-trash-can-outline',
            "small": true,
            "disabled": _vm.camposDesabilitados
          },
          on: {
            "click": function ($event) {
              return _vm.excluirCoordenador(item);
            }
          }
        })], 1)];
      }
    }], null, true)
  })], 1)], 1)], 1), _c('v-divider'), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome Completo do Instrutor",
      "outlined": "",
      "dense": "",
      "counter": "40",
      "maxlength": "40",
      "disabled": _vm.camposDesabilitados
    },
    model: {
      value: _vm.content.nomeDoInstrutor,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nomeDoInstrutor", $$v);
      },
      expression: "content.nomeDoInstrutor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Matrícula",
      "outlined": "",
      "dense": "",
      "maxlength": "12",
      "minlength": "12",
      "counter": "12",
      "hint": "A matrícula do servidor deve conter 12 números.",
      "persistent-hint": "",
      "inputmode": "numeric",
      "disabled": _vm.camposDesabilitados
    },
    on: {
      "keypress": _vm.$validarEntradaNumerica
    },
    model: {
      value: _vm.content.matriculaDoInstrutor,
      callback: function ($$v) {
        _vm.$set(_vm.content, "matriculaDoInstrutor", $$v);
      },
      expression: "content.matriculaDoInstrutor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###.###.###-##',
      expression: "'###.###.###-##'"
    }],
    attrs: {
      "label": "CPF",
      "outlined": "",
      "maxlength": "14",
      "counter": "14",
      "dense": "",
      "disabled": _vm.camposDesabilitados
    },
    on: {
      "keypress": _vm.$validarEntradaNumerica,
      "input": function ($event) {
        return _vm.formatarCpfOnInput('cpfDoInstrutor', $event);
      }
    },
    model: {
      value: _vm.content.cpfDoInstrutor,
      callback: function ($$v) {
        _vm.$set(_vm.content, "cpfDoInstrutor", $$v);
      },
      expression: "content.cpfDoInstrutor"
    }
  })], 1), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.podeAdicionarInstrutor || _vm.camposDesabilitados
    },
    on: {
      "click": _vm.adicionarAtualizarInstrutor
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Incluir Instrutor ")], 1)], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "dense": "",
      "headers": _vm.headersInstrutores,
      "items": _vm.content.instrutores,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.nomeDoInstrutor`,
      fn: function (_ref1) {
        var item = _ref1.item;
        return [_vm._v(" " + _vm._s(item.nomeDoInstrutor) + " ")];
      }
    }, {
      key: `item.matriculaDoInstrutor`,
      fn: function (_ref10) {
        var item = _ref10.item;
        return [_vm._v(" " + _vm._s(item.matriculaDoInstrutor) + " ")];
      }
    }, {
      key: `item.cpfDoInstrutor`,
      fn: function (_ref11) {
        var item = _ref11.item;
        return [_vm._v(" " + _vm._s(_vm.$esconderCpf(item.cpfDoInstrutor)) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref12) {
        var item = _ref12.item,
          index = _ref12.index;
        return [_c('div', {
          key: index
        }, [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true,
            "disabled": _vm.camposDesabilitados
          },
          on: {
            "click": function ($event) {
              return _vm.editarInstrutor(item, index);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Excluir',
            "icon": 'mdi-trash-can-outline',
            "small": true,
            "disabled": _vm.camposDesabilitados
          },
          on: {
            "click": function ($event) {
              return _vm.excluirInstrutor(item);
            }
          }
        })], 1)];
      }
    }], null, true)
  })], 1)], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Valor Total de Investimento*",
      "outlined": "",
      "dense": "",
      "type": "text",
      "rules": [_vm.$required],
      "disabled": _vm.camposDesabilitados,
      "maxlength": "21",
      "counter": "21"
    },
    on: {
      "keypress": _vm.$validarEntradaNumerica,
      "input": _vm.formatarValor
    },
    model: {
      value: _vm.content.valorTotalInvestimento,
      callback: function ($$v) {
        _vm.$set(_vm.content, "valorTotalInvestimento", $$v);
      },
      expression: "content.valorTotalInvestimento"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Escolha a avaliação que os participantes responderão sobre a formação*",
      "outlined": "",
      "dense": "",
      "items": _vm.avaliacoes,
      "item-text": "avaliacao",
      "item-value": "id",
      "disabled": _vm.camposDesabilitados,
      "rules": [_vm.$required]
    },
    on: {
      "focus": _vm.ensureAvaliacoesLoaded
    },
    model: {
      value: _vm.content.avaliacaoId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "avaliacaoId", $$v);
      },
      expression: "content.avaliacaoId"
    }
  })], 1)], 1), !_vm.isFormador && _vm.qtdAjustes >= 3 && !_vm.isViewMode ? _c('div', {
    staticClass: "alert-message d-flex align-center mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Esta Solicitação de Formação já sofreu três ajustes. Não é possível realizar mais alterações.")])], 1) : _vm._e(), _vm.situacaoParaExibirComentario ? _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Comentário",
      "maxlength": "400",
      "counter": "400",
      "dense": "",
      "outlined": "",
      "rows": "6",
      "disabled": _vm.isViewMode || _vm.qtdAjustes >= 3 || _vm.isReenviar()
    },
    model: {
      value: _vm.content.comentario,
      callback: function ($$v) {
        _vm.$set(_vm.content, "comentario", $$v);
      },
      expression: "content.comentario"
    }
  })], 1)], 1) : _vm._e(), !_vm.isFormador ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.content.ultimaAtualizacao))])])])], 1) : _vm._e()], 1)], 1), _c('v-row', {
    staticClass: "d-block text-center btn-group"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [!_vm.isViewMode && _vm.isFormador ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.salvar(false);
      }
    }
  }, [_vm._v(" Salvar ")]) : _vm._e(), !_vm.isViewMode && _vm.isFormador && !_vm.situacaoParaExibirComentario ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.salvar(true);
      }
    }
  }, [_vm.actionIcon ? _c('v-icon', [_vm._v(_vm._s(_vm.actionIcon))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.edit ? 'Editar e Avançar' : 'Salvar e Avançar') + " ")], 1) : _vm._e(), _vm.isFormadorOrAdm && !_vm.isViewMode && _vm.formacaoIdAtual && _vm.situacaoParaExibirComentario ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.solicitarCorrecao
    }
  }, [_vm._v(" Salvar e Avançar ")]) : _vm._e(), !_vm.isViewMode ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v(" " + _vm._s(_vm.isReenviar() ? 'Cancelar' : 'Fechar') + " ")]) : _vm._e(), _vm.isViewMode ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.avancar
    }
  }, [_vm._v(" Avançar ")]) : _vm._e(), _vm.isViewMode ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v(" Fechar ")]) : _vm._e()], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }